import React, { useState } from "react";
import { Toast } from "../../CustomComponent/toast";
import CustomInput from "../../CustomComponent/custom_input";
import FormSubmitButton from "../../Components/layouts/formSubmitButton";
import SimpleButton from "../../Components/layouts/simple_button";
import performRequest from "../../api/request";
import { Form, Formik } from "formik";
import CustomTextArea from "../../CustomComponent/custom_textarea";
import LoadingPage from "../../Components/layouts/loading";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import { enquiryInfo } from "../../SchemaInfo/enquiryInfo";
import { enquirySchema2 } from "../../Schemas/Enquiry/enquiry_schema";
import { Helmet } from "react-helmet-async";
import FooterwithoutLogin from "../../Pages Without Login/controllEnvironmentPolyhouse/footerwithoutLogin";

const EnquiryForm = () => {
  const [loading, setLoading] = useState(false);
  const today = new Date();
  const maxDate = new Date(today);
  maxDate.setDate(today.getDate() + 30);

  const handelSubmit = (values, actions) => {
    if (
      values.phone_number === "0000000000" ||
      values.phone_number === "1111111111" ||
      values.phone_number === "2222222222" ||
      values.phone_number === "3333333333" ||
      values.phone_number === "4444444444" ||
      values.phone_number === "5555555555" ||
      values.phone_number === "6666666666" ||
      values.phone_number === "7777777777" ||
      values.phone_number === "8888888888" ||
      values.phone_number === "9999999999" ||
      values.phone_number === "1234567890" ||
      values.phone_number === "9876543210" ||
      values.phone_number === "0987654321"
    ) {
      Toast("error", "Invalid phone number");
    } else {
      let fname = values.fullName?.trim().split(" ");
      if (fname.length > 1) {
        values = {
          ...values,
          firstName: fname[0]?.trim(),
          lastName: fname[fname.length - 1]?.trim(),
        };
      } else {
        values = {
          ...values,
          firstName: fname[0]?.trim(),
        };
      }
      values = {
        ...values,
        fullName: values.fullName?.trim(),
        email: values.email?.trim(),
        mobileNumber: values.mobileNumber?.trim(),
        notes: values.notes?.trim(),
      };
      setLoading(true);
      performRequest("POST", "/enquiryWebhook/createExhibitionEnquiry", values)
        .then((res) => {
          if (res.status === 201) {
            Toast(
              "success",
              "Thank you for your inquiry—we'll get back to you shortly!"
            );
          } else if (res.status === 200) {
            Toast("error", res.data.message);
          } else {
            Toast("error", "Error while uploading");
          }
        })
        .catch((err) => {
          CustomErrorResponse(err);
        })
        .finally(() => setLoading(false));
    }
  };

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <>
      <Helmet>
        <title>Submit Hydroponic Inquiry | Kryzen</title>
        <meta
          name="description"
          content="Join the Hydroponics Revolution with Kryzen. Submit your inquiry to explore commercial hydroponic farming, get expert consultation, and access India's top farming tech."
        />
        <meta
          name="keywords"
          content="hydroponic inquiry, hydroponic farming, kryzen hydroponics, hydroponic support, agriculture technology, commercial farming"
        />
        <link rel="canonical" href="https://alpha.kryzen.com/client-enquiry" />
        <meta
          property="og:title"
          content="Join the Hydroponics Revolution | Kryzen"
        />
        <meta
          property="og:description"
          content="Submit your inquiry and take your first step toward modern, profitable farming with Kryzen’s expert support and ecosystem."
        />
        <meta
          property="og:url"
          content="https://alpha.kryzen.com/client-enquiry"
        />
        <meta
          property="og:image"
          content="https://res.cloudinary.com/dsmabnook/image/upload/v1757651285/kryzenLogo_v87dtw.png"
        />
        <meta property="og:type" content="website" />
      </Helmet>

      <div className="page">
        <div className="page-wrapper">
          <div className="container-xl">
            <div className="row align-items-center mt-1 px-1">
              <div className="col-4">
                <img
                  width="250px"
                  src="https://res.cloudinary.com/dsmabnook/image/upload/v1757651285/kryzenLogo_v87dtw.png"
                  alt="Kryzen Logo"
                />
              </div>
              <div className="col-8 text-end mt-lg-0 mt-md-0 mt-sm-3 mt-3 fs-3">
                <p>
                  <a href="https://www.kryzen.com">www.kryzen.com</a>
                  <br />
                  <a href="tel:+919870424425"> +91-9870-424-425</a>
                  <br />
                  <a href="mailto:sales@kryzen.com">sales@kryzen.com</a>
                </p>
              </div>
            </div>
            <hr></hr>
            <div className="text-center">
              <div className="">
                <h2>Join the Hydroponics Revolution</h2>
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-md-3 col-lg-3 d-none d-lg-block">
                <div
                  className="card my-4 d-flex justify-content-center align-items-center"
                  style={{ height: "460px" }}
                >
                  <img
                    src="https://res.cloudinary.com/bsgfcooa/image/upload/v1768630216/enquiry_img_roelak.png"
                    style={{ height: "200px" }}
                    alt="Enquiry"
                  />
                </div>
              </div>

              <div className="col-12 col-md-9 col-lg-9 ">
                <div className="card my-4">
                  <div className="card-header">
                    <h3 className="page-title">
                      Please provide your details below.
                    </h3>
                  </div>
                  <Formik
                    initialValues={enquiryInfo}
                    validationSchema={enquirySchema2}
                    onSubmit={handelSubmit}
                  >
                    {(props) => (
                      <Form>
                        <div className="card-body">
                          {/* First Name */}
                          <div className="mb-3 row">
                            <label className="w-25 form-label required col-3">
                              Full name
                            </label>
                            <div className="w-100 col">
                              <CustomInput name="fullName" type="text" />
                              {props.touched.fullName &&
                                props.errors.fullName && (
                                  <p className="text-danger">
                                    {props.errors.fullName}
                                  </p>
                                )}
                            </div>
                          </div>

                          {/* Email */}
                          <div className="mb-3 row">
                            <label className="w-25 form-label col-3">
                              Email
                            </label>
                            <div className="w-100 col">
                              <CustomInput name="email" type="email" />
                              {props.touched.email && props.errors.email && (
                                <p className="text-danger">
                                  {props.errors.email}
                                </p>
                              )}
                            </div>
                          </div>

                          {/* Mobile Number */}
                          <div className="mb-3 row">
                            <label className="w-25 form-label required col-3">
                              Phone number
                            </label>
                            <div className="w-100 col">
                              <CustomInput name="mobileNumber" type="text" />
                              {props.touched.mobileNumber &&
                                props.errors.mobileNumber && (
                                  <p className="text-danger">
                                    {props.errors.mobileNumber}
                                  </p>
                                )}
                            </div>
                          </div>

                          <div className="mb-3 row">
                            <label className="w-25 form-label col-3">
                              What Would You Like to Know?
                            </label>
                            <div className="w-100 col">
                              <CustomTextArea rows={4} name="notes" />
                              {props.touched.notes && props.errors.notes && (
                                <p className="text-danger">
                                  {props.errors.notes}
                                </p>
                              )}
                            </div>
                          </div>
                        </div>

                        {/* Form Actions */}
                        <div className="card-footer">
                          <div className="btn-list justify-content-end">
                            <FormSubmitButton buttonText="Submit Enquiry" />
                            <SimpleButton
                              buttonText="Cancel"
                              type="secondary"
                            />
                          </div>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </div>
              </div>
            </div>
          </div>

          <FooterwithoutLogin />
        </div>
      </div>
    </>
  );
};
export default EnquiryForm;
